import { getCoreURL } from '@api/internal';

export const trackSocialLogin = (
  visitorToken: string | null,
  network: string,
  event: string,
) => {
  try {
    const coreURL = getCoreURL('eu');
    const trackURL = `${coreURL}/auth/social/track`;
    const data = new FormData();
    data.append('event', event);
    data.append('network', network);
    data.append('visitor', visitorToken || '');
    if ('sendBeacon' in navigator) {
      navigator.sendBeacon(trackURL, data);
    } else {
      fetch(`${trackURL}&missingBeacon=true`, {
        method: 'post',
        body: data,
      });
    }
  } catch (error) {
    // We don’t need to capture the exception
  }
};
